import { render } from "./SimulatedUserSettings.vue?vue&type=template&id=2a5314e7&ts=true"
import script from "./SimulatedUserSettings.vue?vue&type=script&lang=ts"
export * from "./SimulatedUserSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__